// A table as the admin boards draw them: a grey header row, then rows on a grid of columns. Under 760px
// each row stacks its cells, each with its column's label above it (styles/admin.css), so every
// column stays readable at 390 wide with no sideways scroll.
//
//   <Table label="People" rowKey={r => r.person_id} rows={rows} empty="Nobody matches that."
//     columns={[
//       { key: 'name', label: 'Name', width: 'minmax(0, 1.1fr)', primary: true,
//         render: r => <><Link to={...} className="ad-td-main">{r.full_name}</Link><span className="ad-td-sub">{r.email}</span></> },
//       { key: 'status', label: 'Status', width: '190px', render: r => <StatusPill status={r.status_key}>...</StatusPill> },
//       { key: 'seen', label: 'Last seen', width: '110px', render: r => <span className="ad-td-quiet">...</span> },
//     ]} />
//
// width: a grid column (minmax(0, 1fr) by default). primary: the cell that heads a stacked row, shown
// without its label. align 'end': pushed to the right at laptop width. onRow: the whole row opens
// something (a keyboard user still uses the link inside it). after(row): drawn under the row across
// every column (a confirm, a form opened from the row).
import { Fragment } from 'react'
import { EmptyState } from './Bits.jsx'

export function Table({ columns, rows, rowKey, label, empty, after, onRow, flush = false, className = '' }) {
  const cols = columns.map(c => c.width || 'minmax(0, 1fr)').join(' ')
  const style = { '--ad-cols': cols }
  return (
    <div className={`ad-table${flush ? ' ad-table--flush' : ''} ${className}`.trim()} role="table" aria-label={label}>
      <div className="ad-thead" role="rowgroup">
        <div className="ad-tr" role="row" style={style}>
          {columns.map(c => <span key={c.key} role="columnheader" className={c.align === 'end' ? 'ad-td--end' : undefined}>{c.label}</span>)}
        </div>
      </div>
      <div className="ad-tbody" role="rowgroup">
        {(rows || []).map((row, i) => {
          const key = rowKey ? rowKey(row, i) : i
          const extra = after ? after(row, i) : null
          return (
            <Fragment key={key}>
              <div className={`ad-tr${onRow ? ' ad-tr--link' : ''}`} role="row" style={style}
                onClick={onRow ? e => { if (!e.target.closest('a, button, input, select, textarea, label')) onRow(row) } : undefined}>
                {columns.map(c => (
                  <span key={c.key} role="cell" data-label={c.primary ? '' : (c.label || '')}
                    className={`ad-td${c.primary ? ' ad-td--primary' : ''}${c.align === 'end' ? ' ad-td--end' : ''}`}>
                    {c.render ? c.render(row, i) : row[c.key]}
                  </span>
                ))}
              </div>
              {extra && <div className="ad-tr-after" role="row"><span role="cell">{extra}</span></div>}
            </Fragment>
          )
        })}
        {(!rows || rows.length === 0) && empty && <div role="row"><span role="cell"><EmptyState>{empty}</EmptyState></span></div>}
      </div>
    </div>
  )
}
